// import pairingErrors from '../../consts/device/pairingErrors';
// import {setIsDeviceReady} from '../../state/ducks/iotDevice/actions';
// import {selectMwDeviceInternalId} from '../../state/selectors/mwDevice';
// import {dispatch, getState} from '../../state/store';
// import deviceTypesService from '../device/deviceTypesService';
// import {log} from '../log';
// import marketConfigService from '../marketConfigService';
// import pairingService from '../pairingService';
import {selectMwDeviceInternalId} from '../../state/selectors/mwDevice';
import {setMwDeviceInternalId} from '../../state/slices/mwDevice';
import scpService from '../scp/scpService';
import {log} from '../log';
import {MW_ERRORS} from '../../consts/app/mwErrors';
import {createError} from '../errors/errorService';
import pairingService from '../pairingService';

export const initConnection = async ({isReconnect, throwException = true, onError, initialDeviceType}) => {
    // const deviceFromStateInternalId = selectMwDeviceInternalId(getState());
    //check if physical device reconnect then get previous serial number from state
    //and if there is no serial number then no real device connect happens before so this is not a logical reconnect
    // const isReconnectAfterPreviousSuccessConnect = isReconnect && deviceFromStateInternalId;

    const scpReadResult = await scpService.identifyDevice({});

    const isDeviceConnected = pairingService.isDeviceConnected();

    if (!isDeviceConnected) {
        throw createError(MW_ERRORS.ERROR_DEVICE_DISCONNECTED, 'Device is disconnected');
    }

    const {serial} = scpReadResult?.charger;

    if (!serial) {
        throw createError(MW_ERRORS.ERROR_READ_DEVICE_DATA, 'No device data');
    }

    setMwDeviceInternalId({deviceSerialNumber: serial, isIdentified: true});

    console.log('selectMwDeviceInternalId(): ' + selectMwDeviceInternalId());

    return scpReadResult;
    // const isWrongDevice = isWrongDeviceReconnected(isReconnectAfterPreviousSuccessConnect, serial);

    // if (isWrongDevice) return;

    // dispatch(setIsDeviceReady());
};

// const isWrongDeviceReconnected = (isReconnect, serial) => {
//     const deviceFromStateInternalId = selectMwDeviceInternalId(getState());

//     const isSameDeviceInState = isReconnect ? deviceFromStateInternalId === serial : true;

//     if (!isSameDeviceInState) {
//         const msg = `There is device with another serialNumber in state, device in state: ${deviceFromStateInternalId}, serial number from response: ${serial}`;

//         log.info(msg);

//         pairingService.disconnectAndShowCriticalGuide();
//         return true;
//     }

//     return false;
// };

export const initHolder = async ({readHolderSerialNumberTimeoutMs} = {}) => {
    const isDeviceConnected = pairingService.isDeviceConnected();

    if (!isDeviceConnected) {
        throw createError(MW_ERRORS.ERROR_DEVICE_DISCONNECTED, 'Device is disconnected');
    }

    const scpReadResult = await scpService.identifyDevice({
        isHolderOnly: true,
        readHolderSerialNumberTimeoutMs,
    });
    const {serial, codentify} = scpReadResult?.holder;

    if (!serial || !codentify) {
        throw createError(MW_ERRORS.ERROR_READ_DEVICE_DATA, 'No holder data');
    }

    return scpReadResult.holder;
};

let onErrorHandler;
let onHolderErrorHandler;
let onSuccessHandler;
let onHolderSuccessHandler;

let onDataChangeHandler;
let onHolderDataChangeHandler;

let onConnectionChangeHandler;
let onHolderConnectionChangeHandler;

let onWebSocketDisconnectHandler;

export const setHandlers = ({onError, onSuccess, isHolder}) => {
    if (isHolder) {
        onHolderErrorHandler = onError;
        onHolderSuccessHandler = onSuccess;
    } else {
        onErrorHandler = onError;
        onSuccessHandler = onSuccess;
    }
};

export const onConnectionDone = ({error, isHolder}) => {
    const status = error ? 'Failed' : 'Success';
    log.info(
        `End synchronization process. ${status}. isHolder: ${isHolder}. ${!!error ? 'error: ' + JSON.stringify(error) : ''}.`
    );

    if (isHolder) {
        return error ? onHolderErrorHandler?.(error) : onHolderSuccessHandler?.();
    }

    return error ? onErrorHandler?.(error) : onSuccessHandler?.();
};

export const onConnectionChange = (connectionStatus) => onConnectionChangeHandler?.(connectionStatus);

export const onHolderConnectedChange = (connectionStatus) => onHolderConnectionChangeHandler?.(connectionStatus);

export const onWebSocketDisconnect = (isHolder) => onWebSocketDisconnectHandler?.(isHolder);

export const onDeviceDataChange = ({deviceData, isHolder}) => {
    if (isHolder) {
        return onHolderDataChangeHandler?.(deviceData);
    }

    return onDataChangeHandler?.(deviceData);
};

export const subscribeOnDataChange = ({onChange, isHolder}) => {
    if (isHolder) {
        onHolderDataChangeHandler = onChange;
    } else {
        onDataChangeHandler = onChange;
    }
};

export const subscribeOnConnectionState = (onConnectionChange) => {
    onConnectionChangeHandler = onConnectionChange;
};

export const subscribeOnHolderConnectedState = (onConnectionChange) => {
    onHolderConnectionChangeHandler = onConnectionChange;
};

export const subscribeOnWebSocketDisconnect = (onConnectionChange) => {
    onWebSocketDisconnectHandler = onConnectionChange;
};
